<div class="container px-0">
  <job-list [jobs]="jobs" *ngIf="jobs" [loadMoreEnabled]="false"></job-list>
</div>